import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ExtendedProjectInfoDc } from "@evergis/api";

import { HTTPStatus } from "../../utils/constants";
import { getCurrentSharedMap } from "../../ducks/location/selectors";
import { useRedirectToEffect } from "../location/useRedirectToEffect";
import { useHttpErrorHandled } from "../useHttpErrorHandled";
import { useSharedService } from "../layer/useSharedService";

export const useSharedProject = (): ExtendedProjectInfoDc => {
  const projectName = useSelector(getCurrentSharedMap);
  const { sharedProject, error } = useSharedService(projectName);
  const [errorHandled] = useHttpErrorHandled(error);

  useRedirectToEffect("404", errorHandled && errorHandled.status === HTTPStatus.NotFound);
  useRedirectToEffect("403", errorHandled && errorHandled.status === HTTPStatus.Forbidden);

  return sharedProject;
};

export const useSharedProjectBaseMap = (): string => {
  const { content } = useSharedProject();
  const { baseMapName } = content;

  return useMemo(() => baseMapName, [baseMapName]);
};
